module.exports = __webpack_public_path__ + "static/tbr-logo-59b1aaccab9ad471b2fb49ca25b26714.svg";